<template>
  <el-dialog
    width="1000px"
    title="选择运输方式"
    :visible.sync="showChangeCateDailog"
    destroy-on-close
    custom-class="revenue-code-number"
  >
    <div class="el-dialog__body-bodys" v-if="showChangeCateDailog">
      <!-- <div class="ccui-app-container-detail">
        <div class="ccui-app-container-detail-body">
          <div class="ccui-top-title">选择商品分类</div>
        
        </div>
      </div> -->
      <el-form
        :inline="true"
        :model="formInline"
        class="ccui-form"
        @submit.native.prevent
      >
        <el-form-item label="运输方式：">
          <el-autocomplete
            class="inline-input search-cate-input"
            ref="searInput"
            v-model.trim="formInline.searchKey"
            clearable
            :fetch-suggestions="querySearch"
            placeholder="请输入四级类目关键字搜索"
            @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item>
          <span class="serch-btn" @click="search">搜索</span>
        </el-form-item>
      </el-form>
      <div class="block">
        <el-cascader-panel
          v-if="cascaderShow"
          v-model="cateValue"
          :props="props"
          label="categoryName"
          value="categoryCode"
          ref="cascader"
        >
        </el-cascader-panel>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="mini" type="default-mini" @click="cancel">
        <!-- 取 消 -->
        取 消
      </el-button>
      <el-button size="mini" type="primary-font-mini" @click="confirmSend">
        <!-- 确 定 -->
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getQryMatSubCatalog, searchCate } from "@/views/lessor-open-shop/api.js";


export default {
  name: "SelectCate",
  data() {
    return {
      showChangeCateDailog: false,
      formInline: {
        searchKey: ""
      },
      restaurants: [],
      props: {
        expandTrigger: "click",
        checkStrictly: true,
        lazy: true,
        label: "classifyName",
        value: "classifyCode",
        lazyLoad(node, resolve) {
          if (node && node.data && node.data.level === 4) {
            resolve([node.data]);
            return;
          }
          let parentCode = node.value ? node.value : "";
          let level = node.level ? node.level : 0;
          let shopId = localStorage.getItem("shopId");
          getQryMatSubCatalog({
            level,
            parentCode,
            shopId,
            isSecondPurchase: 3
          }).then(res => {
            // res.data.data.bos.forEach((item) => {
            // if(item.level===4){
            //   item.leaf = true
            // }
            // });
            resolve(res.data.data);
          });
        }
      },
      cateValue: [],
      cascaderShow: true,
      shopId: ""
    };
  },
  activated() {},
  created() {
    this.shopId = localStorage.getItem("shopId");
  },
  mounted() {},
  methods: {
    open() {
      this.formInline.searchKey = "";
      this.$nextTick(() => {
        this.showChangeCateDailog = true;
      });
    },
    search() {
      this.loadAll(this.formInline.searchKey);
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      // var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(restaurants);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    loadAll(searchKey) {
      searchCate({
        classifyName: searchKey,
        shopId: this.shopId,
        isSecondPurchase: 3
      }).then(res => {
        res.data.data.bos.forEach(item => {
          item.value = item.classifyName;
          item.address = item.classifyCode;
        });
        this.restaurants = res.data.data.bos;
        console.log(this.restaurants);
        this.$refs.searInput.focus();
      });
    },
    handleSelect(item) {
      this.cateValue = [
        item.firstClassifyCode,
        item.secondClassifyCode,
        item.parentCode,
        item.classifyCode
      ];
      // this.cateValue = ["14"];
      this.cascaderShow = false;
      setTimeout(() => {
        this.cascaderShow = true;
      }, 20);
      console.log(this.cateValue);
    },
    _getQryMatSubCatalog() {
      getQryMatSubCatalog();
    },
    handleBack() {
      this.$router.push("/business-goods/goods-distribution/pending");
    },
    cancel() {
      this.showChangeCateDailog = false;
    },

    confirmSend() {
      if (this.cateValue.length < 4) {
        this.$message({
          message: "请选择到第4级分类",
          type: "error",
          ccuiCustom: true,
          showClose: true,
          offset: document.documentElement.clientHeight / 2 - 21
        });
      } else {
        this.cancel();

        this.$emit("ok", this.cateValue);
      }
    },
    nextGo() {
      // let len1 = document.body.querySelectorAll(
      //   ".el-cascader-node.in-active-path"
      // ).length;
      // let len2 = document.body.querySelectorAll(".el-cascader-node.is-active")
      //   .length;
      // let len = len1 + len2;
      // if (len < 4) {
      //   this.$message({
      //     message: "请选择到第4级分类",
      //     type: "error",
      //     ccuiCustom: true,
      //     showClose: true,
      //     offset: document.documentElement.clientHeight / 2 - 21
      //   });
      //   return;
      // }
      // let code = this.$refs.cascader.activePath[3]
      //   ? this.$refs.cascader.activePath[3].value
      //   : this.$refs.cascader.checkedValue[3];
      // this.$router.push("/goods/cy-goodsdistribution/goods-publish/" + code);
      this.$router.push("/business-goods/goods-distribution/goods-publish/");
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .search-cate-input {
  .el-input {
    width: 340px;
    height: 30px;
  }
}
/deep/ .el-scrollbar.el-cascader-menu {
  width: 267px;
  &:nth-child(4) {
    .el-radio {
      visibility: visible;
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
      top: 0;
    }
    .in-active-path {
      color: #4a4a4a;
      background: transparent;
      font-weight: normal;
    }
  }
  &:nth-child(5) {
    display: none;
  }
}
.serch-btn {
  color: #ff0037;
  cursor: pointer;
}
/deep/ .ccui-app-container-detail {
  min-height: calc(100vh - 220px);
  margin: 15px 0 20px;
}
/deep/ .el-cascader-menu__wrap {
  min-height: 400px;
}
.next-btn {
  display: block;
  width: 150px;
  margin: 15px auto;
}
/deep/ .el-radio {
  color: #606266;
  cursor: pointer;
  visibility: hidden; // 加上这一行
  margin-right: 30px;
  display: none;
}
/deep/ .el-cascader-node.is-selectable.in-checked-path {
  background: transparent;
  font-weight: normal;
  color: #4a4a4a;
}
/deep/ .el-cascader-node.is-selectable {
  /*width:220px;*/
  &.in-active-path {
    color: #4a4a4a;
    background: #ffefd5;
    font-weight: normal;
  }
  &.el-cascader-node.is-selectable.is-active {
    font-weight: normal;
    color: #4a4a4a;
    background: #ffefd5;
  }
}
/*/deep/ .el-cascader-menu__list{*/
/*.in-active-path ~ .is-active{*/
/*background: transparent;*/
/*}*/
/*}*/
</style>
